import moment from 'moment-timezone';

import createDateRange from '../utils/date';
import { DATE_DAILY_FORMAT } from '../constants/date';

const initialState = {
  cohortRanges: {
    dailyRange: [],
    weeklyRange: [],
    monthlyRange: [],
  },
};

const meta = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PROJECT_OPTIONS_SUCCESS': {
      const startDate = moment.tz(action.options.startDate, 'YYYY-MM-DD', action.options.zoneId);
      const now = moment();
      return {
        ...state,
        cohortRanges: {
          dailyRange: createDateRange(startDate, now, 'days')
            .sort((a, b) => b.diff(a))
            .map((e) => e.format(DATE_DAILY_FORMAT)),
          weeklyRange: createDateRange(startDate, now, 'week')
            .sort((a, b) => b.diff(a))
            .map((e) => e.format(DATE_DAILY_FORMAT)),
          monthlyRange: createDateRange(startDate, now, 'month')
            .sort((a, b) => b.diff(a))
            .map((e) => e.format(DATE_DAILY_FORMAT)),
        },
      };
    }

    default:
      return state;
  }
};

export default meta;

export const getDailyRange = (state) => state.cohortRanges.dailyRange;
export const getWeeklyRange = (state) => state.cohortRanges.weeklyRange;
export const getMonthlyRange = (state) => state.cohortRanges.monthlyRange;
